<micro-select-combo #sel
              placeholder="Contact Role"
              [mode]="mode"
              [(id)]="role"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>

